// TODO: Applicare FUNA
/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasAffidamento
 * @restrict E
 * @description Componente per caricare il widget del dettaglio affidamento
 */
(function() {
  'use strict';
  var CreasAffidamentoCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    userSrvc,
    messaggiFctr
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    
    this.ndg = this.$stateParams.ndg;

    var self = this;
  };

  CreasAffidamentoCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'UserSrvc',
    'CreasMessaggiFctr'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasAffidamento/creasAffidamento.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasAffidamentoComponent = {
    controller: CreasAffidamentoCtrl,
    controllerAs: 'creasAffidamentoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasAffidamento', CreasAffidamentoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasAffidamento/creasAffidamento.cmpt.js
// module id = 15
// module chunks = 0 1